import { SITE_URL } from "../components/SEO";
import { COMPANY } from "../data/knowledge";

// The company as ONE Schema.org entity, shared by every page that describes
// it (homepage graph, /about). Typed as both Organization and LocalBusiness
// (a subtype of Organization) so the Bhopal office is eligible for local
// results without creating a second, competing entity. Same @id everywhere.
//
// Only facts published on the site are included. Deliberately omitted until
// MagicBolt confirms them (see docs/aeo-geo/AUDIT-2026-09-29.md):
//   openingHoursSpecification, geo (lat/long), priceRange,
//   aggregateRating / review.
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;

export const ORGANIZATION_NODE = {
  "@type": ["Organization", "LocalBusiness"],
  "@id": ORGANIZATION_ID,
  name: COMPANY.legalName,
  legalName: COMPANY.legalName,
  alternateName: COMPANY.brand,
  url: SITE_URL,
  logo: `${SITE_URL}/logos/magicbolt.webp`,
  image: `${SITE_URL}/logos/magicbolt.webp`,
  description: COMPANY.summary,
  email: COMPANY.email,
  telephone: COMPANY.phone,
  address: { "@type": "PostalAddress", ...COMPANY.address },
  // Confirmed by MagicBolt 2026-09-29: India-based, serves customers worldwide.
  areaServed: "Worldwide",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: COMPANY.phone,
    email: COMPANY.email,
    contactType: "sales",
  },
  // NOTE: the LinkedIn URL is a personal-profile ("/in/") slug, not a
  // company page ("/company/") - swap it in knowledge.js if one exists.
  sameAs: COMPANY.officialLinks.map((l) => l.url),
};
